<div class="input-grid-gaps wrapper">
    <app-button
        [icon]="item().completedAt ? 'pi-check-circle' : 'pi-circle'"
        [text]="true"
        [severity]="item().completedAt ? 'success' : 'secondary'"
        (clickEvent)="toggleCompleteItem($event)"
    ></app-button>
    <div
        class="title"
        [class.completed]="item().completedAt"
    >
        {{ item().title }}
    </div>
    <div>
        @if (status() && (!item().completedAt || status()?.severity === 'danger')) {
            <app-tag
                [severity]="status()!.severity"
                [label]="status()!.title"
                [rounded]="true">
            </app-tag>
        }
    </div>
    <div>
        @if (item().files.length > 0) {
            <app-button
                icon="pi-link"
                class="files"
                pBadge
                [value]="item().files.length"
                [rounded]="true"
                [text]="true"
            ></app-button>
        }
    </div>
    <div class="flex gap-x-small div-ellipsis" [pTooltip]="item().tags.join(', ')">
        @if (Array.isArray(item().tags)) {
            @for (tag of item().tags; track $index) {
                <app-tag
                    [label]="tag"
                    [rounded]="true">
                </app-tag>
            }
        }
    </div>
    <div>
        @if (item().shareUsers && Array.isArray(item().shareUsers)) {
            <p-avatarGroup>
                @for (user of item().shareUsers; track user.id) {
                    <app-avatar
                        [initials]="user.user | personInitials"
                        [src]="user.user.image"
                        [tooltip]="true"
                        [person]="$any(user.user)"
                    ></app-avatar>
                }
            </p-avatarGroup>
        }
    </div>
    <div class="flex gap-small">
        <app-button
            icon="pi-pencil"
            [text]="true"
            (clickEvent)="showDetail()"
        ></app-button>
        <app-button
            icon="pi-trash"
            severity="danger"
            [text]="true"
            (clickEvent)="deleteItem($event)"
        ></app-button>
    </div>
</div>
